export default __webpack_public_path__ + "0b1ff7a9e57c2df19af068e443c3e583.png";